import Link from 'next/link';

import { useLandingProductGTM } from '@/fo/api/gtm';
import AddToCartIcon from '@/fo/icons/base/landing/add-to-cart.svg';
import { cartActions } from '@/fo/store/product';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { Product } from '@/fo/ui/landing/product-card/esthederm';
import { staticMediaUrl } from '@/fo/util/image-loader';
import { reachMetrikaGoal } from '@/fo/util/metrics';

import { styles } from './CareSection.styles';

export interface CareSectionProps {
  products: Product[];
}

export function CareSection({ products }: CareSectionProps) {
  const slots = styles();

  return (
    <div
      className={slots.base()}
      id="additional-care"
    >
      <h3 className={slots.title()}>
        ПОЛНАЯ ПРОГРАММА УХОДА{' '}
        <span className={slots.semibold()}>INTENSIVE&nbsp;NAD+</span>
      </h3>
      <UiKitCarouselBase
        className={slots.carousel()}
        loop={false}
        alwaysShowArrows
        arrowPrevClass={slots.arrowPrev()}
        arrowNextClass={slots.arrowNext()}
      >
        {products.map((product, index) => (
          <CareProductCard
            key={product.sku}
            product={product}
            positionIndex={index}
          />
        ))}
      </UiKitCarouselBase>
      <div className={slots.imageWrapper()}>
        <img
          className={slots.image()}
          src={staticMediaUrl('landing/ie_intensive_nad/woman2.png')}
          alt="INTENSIVE NAD+"
        />
      </div>
    </div>
  );
}

function CareProductCard({
  product,
  positionIndex
}: {
  product: Product;
  positionIndex: number;
}) {
  const slots = styles();
  const { ref, onSelectItem, viewItemList } = useLandingProductGTM(
    product,
    positionIndex
  );
  const imageSrc =
    product.image?.md || product.image?.sm || product.baseImage?.src || '';

  const onProductClick = () => {
    onSelectItem();
    reachMetrikaGoal('perehod_v_kartochku_tovara');
  };

  return (
    <div
      ref={ref}
      className={slots.productCard()}
    >
      {viewItemList}
      <Link
        href={product.link || '#'}
        target="_blank"
        className={slots.glass()}
        onClick={onProductClick}
      >
        {imageSrc && (
          <img
            className={slots.productImage()}
            src={imageSrc}
            alt={product.name || ''}
          />
        )}
      </Link>
      <div className={slots.content()}>
        <Link
          href={product.link || '#'}
          target="_blank"
          className={slots.heading()}
          onClick={onProductClick}
        >
          {product.heading}
        </Link>
        {product.text && <p className={slots.text()}>{product.text}</p>}
        {product.basePrice && (
          <div className={slots.action()}>
            <UiKitPriceBase
              value={product.finalPrice || product.basePrice || 0}
              oldValue={product.basePrice}
              className={slots.price()}
              classNameValue={slots.priceValue()}
              classNameOldValue={slots.priceOld()}
            />
            <button
              className={slots.button()}
              onClick={() => {
                cartActions.addProductsToCart([
                  {
                    sku: product.sku ?? '',
                    quantity: 1,
                    product: {
                      sku: product.sku ?? '',
                      name: product.name || '',
                      brand: product.brand || '',
                      series: product.series || '',
                      volume: product.volume || '',
                      basePrice: product.basePrice || 0,
                      finalPrice: product.finalPrice || null,
                      baseImage: product.baseImage || {
                        src: '',
                        alt: ''
                      }
                    }
                  }
                ]);
                reachMetrikaGoal('dobavlenie_v_korzinu');
              }}
            >
              <AddToCartIcon />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
